// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation-D":"NA_outdoor-recreation-D__LuZH_"};